/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { OrderCorrectionRequestDto } from '../model/orderCorrectionRequestDto';
// @ts-ignore
import { OrderDto } from '../model/orderDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface CorrectOrderRequestParams {
  orderCorrectionRequestDto: OrderCorrectionRequestDto;
}

export interface GetOrderByIdRequestParams {
  id: number;
}

export interface GetOrdersRequestParams {
  /** Include Account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Exclude Account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Include Pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairId?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairId\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Order statuses for filtering */
  orderStatus?: Array<
    'ACTIVE' | 'CANCELED' | 'FILLED' | 'PARTIALLY_FILLED' | 'PARTIALLY_FILLED_CANCELED' | 'REJECTED' | 'WAITING_TRIGGER'
  >;
  /** If true - exclude account House. */
  excludeHouseLp?: boolean;
  /** If true - filled quantity exists. */
  existFilledQty?: boolean;
  /** Jurisdiction for filtering. */
  jurisdiction?: string;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Sort direction by receiveTime column. ASC or DESC(default) */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0 */
  skipCount?: number;
  /** If true - returns only active orders */
  activeOnly?: boolean;
  /** Initiator type */
  initiatorType?: 'ADMIN' | 'API_KEY' | 'USER' | 'ALGO' | 'FIX';
  /** Client order Id for filtering */
  clOrdId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OrdersControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Corrects order
   * @endpoint post /v1/orders/correct
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public correctOrder(
    requestParameters: CorrectOrderRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<OrderDto>;
  public correctOrder(
    requestParameters: CorrectOrderRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<OrderDto>>;
  public correctOrder(
    requestParameters: CorrectOrderRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<OrderDto>>;
  public correctOrder(
    requestParameters: CorrectOrderRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const orderCorrectionRequestDto = requestParameters?.orderCorrectionRequestDto;
    if (orderCorrectionRequestDto === null || orderCorrectionRequestDto === undefined) {
      throw new Error('Required parameter orderCorrectionRequestDto was null or undefined when calling correctOrder.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/orders/correct`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<OrderDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: orderCorrectionRequestDto,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets order by id
   * @endpoint get /v1/orders/{id}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getOrderById(
    requestParameters: GetOrderByIdRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<OrderDto>;
  public getOrderById(
    requestParameters: GetOrderByIdRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<OrderDto>>;
  public getOrderById(
    requestParameters: GetOrderByIdRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<OrderDto>>;
  public getOrderById(
    requestParameters: GetOrderByIdRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getOrderById.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/orders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<OrderDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets orders(up to 100)
   * @endpoint get /v1/orders
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getOrders(
    requestParameters?: GetOrdersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<OrderDto>>;
  public getOrders(
    requestParameters?: GetOrdersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<OrderDto>>>;
  public getOrders(
    requestParameters?: GetOrdersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<OrderDto>>>;
  public getOrders(
    requestParameters?: GetOrdersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const pairId = requestParameters?.pairId;
    const excludePairIds = requestParameters?.excludePairIds;
    const orderStatus = requestParameters?.orderStatus;
    const excludeHouseLp = requestParameters?.excludeHouseLp;
    const existFilledQty = requestParameters?.existFilledQty;
    const jurisdiction = requestParameters?.jurisdiction;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const activeOnly = requestParameters?.activeOnly;
    const initiatorType = requestParameters?.initiatorType;
    const clOrdId = requestParameters?.clOrdId;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'orderStatus',
      <any>orderStatus,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeHouseLp',
      <any>excludeHouseLp,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'existFilledQty',
      <any>existFilledQty,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'activeOnly',
      <any>activeOnly,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'initiatorType',
      <any>initiatorType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'clOrdId',
      <any>clOrdId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/orders`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<OrderDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
